import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { NotificationManager } from 'react-notifications';
import LoggedInContainer from '../../components/loggedInContainer/loggedInContainer';
import CreateOrderForm from '../../components/createOrderForm/createOrderForm';
import http from '../../services/http';

import './createOrder.less';

class CreateOrderPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      products: [],
      address: {},
      isReady: false,
    };
  }

  async componentDidMount() {
    await this.getProductList();
    await this.getClientAddress();

    this.setState({ isReady: true });
  }

  getProductList = async () => {
    try {
      const products = await http.get('/api/client/getproducts');

      this.setState({
        products,
      });
    } catch (err) {
      console.error(err);
      NotificationManager.error('Nie udało się pobrać listy produktów', 'Błąd', 5000);
    }
  }

  getClientAddress = async () => {
    try {
      const address = await http.get('/api/client/getaddress');

      this.setState({ address });
    } catch (err) {
      console.error(err);
      NotificationManager.error('Nie udało się pobrać zapisanego adresu', 'Błąd', 5000);
    }
  }

  render() {
    const { products, address, isReady } = this.state;

    return (
      <LoggedInContainer>
        <Paper className="create-order-paper-box">
          <div className="page-title">
            <Typography variant="h5">
              Złóż zamówienie
            </Typography>
          </div>
          {isReady && <CreateOrderForm products={products} address={address} />}
        </Paper>
      </LoggedInContainer>
    );
  }
}

export default CreateOrderPage;
